import type { Action, ThunkAction } from "@reduxjs/toolkit";
import {
  combineReducers,
  configureStore,
  createAction,
} from "@reduxjs/toolkit";
import authReducer from "@/features/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";

// 1. Create a global action for logging out
export const logout = createAction("app/logout");

// 2. Combine your slice reducers into a single app reducer
const appReducer = combineReducers({
  auth: authReducer,
  // Add other slices here as your app grows
});

// 3. Create a root reducer that resets state to undefined on logout
const rootReducer = (
  state: ReturnType<typeof appReducer> | undefined,
  action: Action,
) => {
  if (action.type === logout.type) {
    // Setting state to undefined forces all slice reducers to return their initial state
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;
export type AppThunk<ThunkReturnType = void> = ThunkAction<
  ThunkReturnType,
  RootState,
  unknown,
  Action
>;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
